import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    meta: { title: "Servicios Universidad Iberoamericana" },
    component: () =>
        import('../views/Home.vue')
},
{
    path: '/Login',
    name: 'Login',
    meta: { title: "Campus Virtual Universidad Iberoamericana" },
    component: () =>
        import('../views/modules/Pages/Login.vue')
},
{
    path: '/Ibero',
    name: 'Ibero',
    meta: { title: "Campus Virtual Universidad Iberoamericana" },
    component: () =>
        import('../views/modules/Pages/Ibero.vue')
},
{
    path: '/Voting',
    name: 'Votaciones',
    meta: { title: "Votaciones Universidad Iberoamericana" },
    component: () =>
        import('../views/modules/Voting/Voting.vue')
},
{
    path: '/formulario-inscripcion/:referencia/:operador?',
    name: 'InscriptionForm',
    meta: { title: "Formulario de Inscripción" },
    component: () =>
        import('../views/modules/Forms/Inscripcion.vue')
},
{
    path: '/formulario-inscripcion-it/:referencia/:operador?',
    name: 'InscriptionForm',
    meta: { title: "Formulario de Inscripción" },
    component: () =>
        import('../views/modules/Forms/Inscripcion2.vue')
},
{
    path: '/archivos-inscripcion/:docType?/:docNum?/:celNum?/:mailRef?',
    name: 'InscripcionFiles',
    meta: { title: "Inscripción de Documentos" },
    component: () =>
        import('../views/modules/Forms/InscripcionFiles.vue')
},
{
    path: '/formulario-pqrs/:docType?/:docNum?',
    name: 'PQRSForm',
    meta: { title: "Formulario Atención de PQRs" },
    component: () =>
        import('../views/modules/Forms/FormPQRS.vue')
},
{
    path: '/recibo-inscripcion/:docType?/:docNum?',
    name: 'InscripcionOrder',
    meta: { title: "Recibo de Inscripción y Pago en Línea" },
    component: () =>
        import('../views/modules/Forms/InscriptionOrder.vue')
},
{
    path: '/recibo-pago-certificado/',
    name: 'PayOrderCertificate',
    meta: { title: "Comprobante de pago certificados" },
    component: () =>
        import('../views/modules/Forms/PayOrderCertificate.vue')
},
{
    path: '/diplomas',
    name: 'Diplomas',
    meta: { title: "Descarga tus diplomas" },
    component: () =>
        import('../views/modules/Forms/Diplomas.vue')
},
{
    path: '/asesores',
    name: 'asesores',
    meta: { title: "Consulta tu asesor" },
    component: () =>
        import('../views/modules/Forms/AsesoresRemake.vue')
},
{
    path: '/egresados',
    name: 'agresados',
    meta: { title: "Actualización de datos de Egresados" },
    component: () =>
        import('../views/modules/Forms/GraduatedForm.vue')
},
{
    path: '/Contrasena-zafiro',
    name: 'ZafiroPassword',
    meta: { title: "Restablecimiento de contraseña ZAFIRO" },
    component: () =>
        import('../views/modules/Forms/ZafiroPassword.vue')
},
{
    path: '/solicitar-certificados',
    name: 'ApplyCertificate',
    meta: { title: "Solicitar Certificado" },
    component: () =>
        import('../views/modules/Forms/ApplyCertificate.vue')
},
{
    path: '/copia-recibo',
    name: 'BillCopy',
    meta: { title: "Solicitar Copia de Recibo de Pago" },
    component: () =>
        import('../views/modules/Forms/BillCopy.vue')
},
{
    path: '/restablecer-contrasena-correo',
    name: 'BillCopy',
    meta: { title: "Restablecimiento de Contraseña de Correo Electrónico" },
    component: () =>
        import('../views/modules/Forms/RestorePassword.vue')
},
{
    path: '/Certificados',
    name: 'CertificadosForm',
    meta: { title: "Certificados" },
    component: () =>
        import('../views/modules/Forms/Certificados.vue')
},
{
    path: '/Estados_Casos',
    name: 'Estados_Casos',
    meta: { title: "Consulta el estado de tu petición" },
    component: () =>
        import('../views/modules/Forms/StatusHistoryCase.vue')
},
{
    path: '/test_vocacional',
    name: 'test_vocacional',
    meta: { title: "Test Vocacional" },
    component: () =>
        import('../views/modules/Forms/testvocacional/TestVocacional.vue')
},
{
    path: '/Cursos-Cortos/:operador/:curso',
    name: 'ShortCourse',
    meta: { title: "Cursos Cortos IBEROAMERICANA" },
    component: () =>
        import('../views/modules/Forms/ShortCourses.vue')
},
{
    path: '/Account',
    name: 'Account',
    meta: { title: "Cuenta del Usuario" },
    component: () =>
        import('../views/modules/Users/Account.vue')
},
{
    path: '/Settings',
    name: 'Settings',
    meta: { title: "Actualizacion del Usuario" },
    component: () =>
        import('../views/modules/Users/Settings.vue')
},
{
    path: '*',
    name: 'not-found',
    meta: { title: "Pagina no encontrada" },
    component: () =>
        import('../views/Home.vue')
},
{
    path: '/evento-investigaciones',
    name: 'EventFonoaudiologia',
    meta: { title: "Pagos en Linea Ibero 2026" },
    component: () =>
        import('../views/modules/Forms/EventFono.vue')
}
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router